export enum ContactRoles {
  MANAGER = 'roles.contactManager',
}
